import React, { useState, useCallback, useEffect } from 'react'
import {
  LegacyCard,
  LegacyFilters,
  DataTable,
  Toast,
  Button,
  Link,
  LegacyTabs,
} from '@shopify/polaris'
import { useDispatch, useSelector } from 'react-redux'
import BookingActions from 'Redux/BookingRedux'
import Loader from 'Components/Loader'
import moment from 'moment'
import useDebounce from 'Hooks/debounce'
import { useParams, useHistory } from 'react-router-dom'

let headings = [
  'Product Name',
  'Email',
  'Subscription Type',
  'Subscription Status',
  'Bookings Status',
  '',
]

const CustomerSubscription = (props) => {
  const dispatch = useDispatch()
  const [bookings, setBookings] = useState([])
  const [queryValue, setQueryValue] = useState('')
  const history = useHistory()

  useEffect(() => {
    dispatch(BookingActions.bookingsSubscriptionsListRequest())
  }, [dispatch])

  const bookingsList = useSelector((state) => state.booking.list)
  const bookingsFetching = useSelector((state) => state.booking.listFetching)
  const listDataOffset = useSelector((state) => state.booking.listDataOffset)

  const filters = []
  const appliedFilters = []

  const formatBookingsList = (bookingsList) => {
    return renderSubscriptionsView(bookingsList)
  }

  const manageSubscription = (s) => () => {
    history.push(`/apps/customer_portal/subscription_bookings/${s.uuid}`)
  }

  const renderSubscriptionsView = () => {
    return bookingsList.map((o) => {
      let values = []

      headings.map((h) => {
        let content = ''
        switch (h) {
          case 'Product Name':
            let m = o.metadata
            content = (
              <div className="exclude-translation notranslate">
                <p>
                  {!!m && m.lines && m.lines.length > 0
                    ? `${m.lines[0].title} - ${m.lines[0].variantTitle || ''}`
                    : ''}
                </p>
              </div>
            )
            break
          case 'Email':
            content = (
              <p className="exclude-translation notranslate">
                {o.metadata && o.metadata.customer
                  ? o.metadata.customer.email
                  : ''}
              </p>
            )
            break
          case 'Subscription Type':
            content = (
              <p className="exclude-translation notranslate">
                {o.subscription_type === 'recurring' ? 'Recurring' : 'Fixed'}
              </p>
            )
            break
          case 'Subscription Status':
            content = (
              <p className="exclude-translation notranslate">{o.status}</p>
            )
            break
          case 'Bookings Status':
            content = (
              <p className="exclude-translation notranslate">
                {o.curr_booking_count}/{o.max_booking_count}
              </p>
            )
            break
          default:
            content = (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                }}
              >
                <Button onClick={manageSubscription(o)} variant="primary">
                  Manage
                </Button>
              </div>
            )
            break
        }
        values.push(content)
      })

      return values
    })
  }
  const allBookings = formatBookingsList(bookingsList)

  useEffect(() => {
    setBookings(allBookings)
  }, [bookingsList])

  return (
    <div>
      <LegacyCard>
        {bookingsFetching ? (
          <Loader />
        ) : bookingsList.length > 0 || listDataOffset > 0 ? (
          <>
            <DataTable
              columnContentTypes={['text', 'text', 'text', 'numeric']}
              headings={headings}
              rows={bookings}
            />
          </>
        ) : (
          <LegacyCard>
            <div
              style={{
                display: 'flex',
                height: 300,
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
              }}
            >
              No Subscription Booking. Please purchase one from the store
            </div>
          </LegacyCard>
        )}
      </LegacyCard>
    </div>
  )
}

export default CustomerSubscription
